import Alpine from "alpinejs"
import Swiper from "swiper"
import { Navigation, Mousewheel, Pagination } from "swiper/modules"

Alpine.data('CardCarousel', () => ({
    swiper: false,
    swiperIndex: 1,
    init(){
        let swiperContainer = this.$el;
        this.swiper = new Swiper(swiperContainer, {
            modules: [Navigation, Mousewheel, Pagination],
            slidesPerView: 1.1,
            centeredSlides: true,
            mousewheel: {
                forceToAxis: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                bulletActiveClass: 'bg-button',
                bulletClass: 'w-3 h-3 border-button border-1 rounded-full cursor-pointer',
                clickable: true
            },
            spaceBetween: 16,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    centeredSlides: false,
                },
                1024: {
                    slidesPerView: 3,
                    centeredSlides: false,
                    centerInsufficientSlides: true,
                    allowTouchMove: false,
                }
            }
        });

        if (this.swiper) {
            this.swiper.on('slideChange', () => {
                this.swiperIndex = swiper.activeIndex + 1;
            });
        }

        //Unknown as to why but this is the only fix for a bug where a disabled state was being applied to the nav on page load 
        document.addEventListener("DOMContentLoaded", () => {
            this.swiper.navigation.update();
        });
    }, 
}));